// extracted by mini-css-extract-plugin
export default {"root":"_2jPGh","cover":"YpNhf","middle":"TP8VS","underlay":"_3b-i8"};